import styled from 'styled-components';

export const LoadingContainer = styled.div`
  min-height: 518px;
`;
